import React from 'react'
import PropTypes from 'prop-types'
import {
  Icon,
  Inner,
  CheckboxWrapper,
  CheckboxWithLabelWrapper
} from './styles'

const Checkbox = ({ sm, backgroundColor, disabled, selected, invalid, onChange }) => (
  <CheckboxWrapper
    sm={sm}
    invalid={invalid}
    selected={selected}
    disabled={disabled}
    backgroundColor={backgroundColor}
    onClick={disabled ? null : onChange}
  >
    <Inner>
      <Icon sm={sm} />
    </Inner>
  </CheckboxWrapper>
)

Checkbox.defaultProps = {
  sm: false,
  selected: false,
  backgroundColor: null
}

Checkbox.propTypes = {
  sm: PropTypes.bool,
  selected: PropTypes.bool,
  backgroundColor: PropTypes.string,
  onChange: PropTypes.func
}

export const CheckboxWithLabel = ({ label, ...rest }) => (
  <CheckboxWithLabelWrapper>
    <Checkbox {...rest} />
    <label>{label}</label>
  </CheckboxWithLabelWrapper>
)

export default Checkbox



// WEBPACK FOOTER //
// ./src/Components/Checkbox/Checkbox.jsx